import { makeStyles } from "@material-ui/core";

export const washDashboardStyles = makeStyles((theme) => ({
    card: {
        //margin: '1rem 0',
        padding: '1.5em ',
        height: '100%',

    },
    graphWrapper: {
        height: '100%',
        minHeight: '250px',
        position: 'relative'
    },
    subTitle: {
        color: theme.palette.primary.dark,
        fontSize: '1.1em',
        fontWeight: 500,
        marginTop: 0,
        marginBottom: 0,
        paddingBottom: 0
    },
    wrapper: {
        height: '100%',
        position: 'relative'
    },
    count: {
        color: theme.palette.primary.main,
        fontSize: '3.5em',
        fontWeight: 700
    },
    text: {
        color: theme.palette.primary.dark,
        fontSize: 20,
        fontWeight: 500,
        marginTop: 0,
    },
    tooltip: {
        background: '#fff',
        padding: '1em',
        boxShadow: '1px 2px 7px #efefef'
    },
    washIcon: {
        '& svg': {
            width: '3em',
            height: '3em'
        }
    },
    listBtn: {
        position: 'absolute',
        right: '0'
    }
}));